import { useFormikContext } from 'formik';
import React, { ChangeEvent, memo } from 'react';
import { Checkbox } from '../../../../../components/forms/fields-next';
import { EditableEquipmentItem } from '../../../types';
import { isEditEquipItem } from '../utils';
import TreeListCellWrapper from './TreelistCellWrapper';
import { CustomTreeListCellProps } from './types';

const LHRTParameterEditor: React.FC<{ field: string }> = ({ field }) => {
  const { getFieldProps, setFieldValue, values } = useFormikContext<EditableEquipmentItem>();

  const handleExpiredLotChange = (_: ChangeEvent<{}>, checked: boolean) => {
    setFieldValue(field, !!checked);
  };

  return (
    <Checkbox
      checked={values[field]}
      {...getFieldProps(field)}
      onChange={handleExpiredLotChange}
    />
  );
};

const LHRTParameterCell: React.ComponentType<CustomTreeListCellProps> = (props) => {
  const { field = '', dataItem } = props;
  const isEditMode = isEditEquipItem(dataItem);

  return (
    <TreeListCellWrapper {...props}>
      {isEditMode
        ? <LHRTParameterEditor field={field} />
        : <Checkbox checked={dataItem[field]} disabled />}
    </TreeListCellWrapper>
  );
};

export default memo(LHRTParameterCell);
